module.exports = __webpack_public_path__ + "static/img/ikonaPobierz-OFF.075556d2.png";